var map = {
	"./amex.svg": 417518,
	"./diners.svg": 775604,
	"./discover.svg": 163290,
	"./jcb.svg": 476500,
	"./mastercard.svg": 327943,
	"./unionpay.svg": 758790,
	"./visa.svg": 701964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284769;